export enum ExternalNumberAction {
    APPEND = "Подключение", REMOVE = "Отключение"
}
